/**
 * Created by Lior Elrom
 * Date: 7/12/16
 * Time: 12:09 PM
 */

'use strict';

const GA_TYPES = {
    TYPE_ENTRY: 'entry',
    TYPE_SAVED: 'saved',
    TYPE_COMPLETED: 'completed'
};
const GA_BOOLEANS = {
    BOOLEAN_YES: 'y',
    BOOLEAN_NO: 'n'
};
const GA_FRAGMENT = {
    FRAGMENT_PURCHASABLE: 'pur',
    FRAGMENT_NEGOTIABLE: 'neg',
    FRAGMENT_RETURNABLE: 'ret',
    FRAGMENT_RELEASED_DATE: 'released',
    FRAGMENT_SOLD_DATE: 'sold',
    FRAGMENT_PRE_QUOTED_SHIPPING: 'ship'
};

module.exports = {
    GA_TYPES,
    GA_BOOLEANS,
    GA_FRAGMENT
};



// WEBPACK FOOTER //
// ./assets/js/checkout/models/CheckoutGAConstants.es.js